import { type ApolloError, useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { type VisaApplication } from './types';

export const useGetVisaApplication = (
  applicationId: string,
  skip?: boolean,
): {
  data: VisaApplication;
  loading: boolean;
  error?: ApolloError;
  refetch: () => void;
} => {
  const { data, loading, error, refetch } = useQuery(
    gql`
      query ($applicationId: ID!) {
        visa(filter: { applicationId: { eq: $applicationId } }) {
          applicationId
          referenceNo
          status
          applicationDate
          visaDocument {
            id
            link
            name
          }
          entrySlipDocument {
            id
            link
            name
          }
        }
      }
    `,
    {
      variables: { applicationId },
    },
  );

  return {
    data: data?.visa as VisaApplication,
    loading,
    error,
    refetch,
  };
};
